import { useState, useEffect } from 'react';
import { Form, Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from "../inputs/text-input";
import Cookies from 'js-cookie';
import Buttons from "../buttons/button-primary";
import ButtonsSecondary from "../buttons/button-secondary";
import OtpInputNumber from "../inputs/otp-input";
import InputNumber from "../inputs/number-input";
import validateMobile from "./registerEditMobileNumberValidation";
import { registerResendOtp, clearRegisterResendOtpMessages } from "../../redux/actions/registrationResendOtp";
import axios from 'axios';
import API from '../../API';
// registerPersonal
const LoginOTP = (props) => {
    const [isOpen, openModal] = useState(false);
    const dispatch = useDispatch();
    const personalError = useSelector(state => state.registerOtp.error);
    const resendOtpError = useSelector(state => state.registerResendOtp.error);
    const resendOtpSuccess = useSelector(state => state.registerResendOtp.success);
    const registerPersonal = useSelector(state => state.registerPersonal.registration);
    const toggleModal = () => openModal(!isOpen);
    const [state, setState] = useState({
        mobileNumber: Cookies.get('mobileNumber'),
        otp: "",
        otpError: "",
        mobileNumberError: "",
        changedMobileNumber: "",
        changedMobileNumberError: "",
        apiError: "",
    })

    // Test API call when user enters OTP verification step
    useEffect(() => {
        if (registerPersonal && registerPersonal.data) {
            // Call test API to get OTP details
            axios.get(API.baseURL + `/get_user_details?mobile_number=${registerPersonal.data.email}`, API.options)
                .then(response => {
                    console.log('Test API response:', response.data);
                })
                .catch(error => {
                    console.log('Test API call failed:', error);
                });
        }
    }, [registerPersonal]);
    const handleChange = (data) => {
        setState((prevProps) => ({
            ...prevProps,
            otp: data,
            otpError: "", // Clear OTP error when user starts typing
        }))
        // Clear any existing errors when user starts typing
        if (props.otpError) {
            if (props.onOtpErrorClear) {
                props.onOtpErrorClear();
            }
        }
        if (resendOtpError || resendOtpSuccess) {
            dispatch(clearRegisterResendOtpMessages());
        }
    }
    const handleResendOtp = (confirmation_token) => {
        // Clear all errors before making the API call
        if (props.onOtpErrorClear) {
            props.onOtpErrorClear();
        }
        // Clear resend OTP messages by dispatching a clear action
        dispatch(clearRegisterResendOtpMessages());
        // Clear OTP input
        setState((prevProps) => ({
            ...prevProps,
            otp: "",
        }));
        dispatch(registerResendOtp(confirmation_token))
    };
    const handleBack = () => {
        // Call the back handler passed from parent component
        if (props.onBack) {
            props.onBack();
        }
    };
    const numberUpdate = (event) => {
        event.preventDefault()
        console.log(registerPersonal, "registerPersonal");
        
        const errors = validateMobile(state)
        const data = {
            user_id: registerPersonal.data.id,
            mobile_number: state.changedMobileNumber
        }
        
        if (errors.valid) {
            // Clear any previous API errors
            setState((prevProps) => ({
                ...prevProps,
                apiError: "",
            }));
            
            axios.put(API.baseURL + "/providers/update_mobile_number_without_login ", data, API.options)
                .then(response => {
                    console.log(response.data);
                    setState((prevProps) => ({
                        ...prevProps,
                        mobileNumber: state.changedMobileNumber,
                        apiError: "",
                    }));
                    // Only close modal on success
                    toggleModal();
                })
                .catch(error => {
                    console.log(error);
                    // Extract error message from API response
                    const errorMessage = error.response?.data?.data?.message || 
                                       error.response?.data?.message || 
                                       error.response?.data?.error || 
                                       error.response?.data?.errors?.[0] || 
                                       "Failed to update mobile number. Please try again.";
                    
                    setState((prevProps) => ({
                        ...prevProps,
                        apiError: errorMessage,
                    }));
                    // Don't close modal on error
                });
        }
    }
    const handleMobileChange = (event) => {
        const value = event.target.value;
        console.log(value);
    
        // Check for special characters in the raw input value
        const hasSpecialChars = /[+\-]/.test(value);
        // Remove any non-digit characters
        const digitsOnly = value.replace(/[+\-\D]/g, '');
        
        if (hasSpecialChars) {
            console.log("special characters");
            
            setState((prevProps) => ({
                ...prevProps,
                changedMobileNumber: digitsOnly,
                changedMobileNumberError: "Special characters (+/-) are not allowed",
                apiError: "",
            }));
            // Prevent the default behavior
            event.preventDefault();
        } else if (digitsOnly.length > 10) {
            setState((prevProps) => ({
                ...prevProps,
                changedMobileNumber: digitsOnly.slice(0, 10),
                changedMobileNumberError: "Mobile number should be 10 digits only",
                apiError: "",
            }));
        } else {
            setState((prevProps) => ({
                ...prevProps,
                changedMobileNumber: digitsOnly,
                changedMobileNumberError: digitsOnly.length < 10 && digitsOnly.length > 0 ? 
                    "Please enter 10 digits" : "",
                apiError: "",
            }));
        }
    }
    return (
        <>
            <Row form>
                <Col sm="12">
                    <div className="position-relative mt-3">
                        <InputText
                            disabled={true}
                            label="Mobile Number"
                            value={state.mobileNumber}
                            name="login_number"
                            id="login_number"
                        />
                        <div className="ebw-input__option-edit position-absolute" onClick={() => toggleModal()}>Edit</div>
                    </div>
                    <div className="d-flex flex-row justify-content-between align-items-center  ml-2 ml-md-4 mr-2">
                        <div onClick={() => handleResendOtp(registerPersonal.data.confirmation_token)} className="ebw-entry__tab-forgot ml-auto">
                            <a className="mb-0 text-sm ebw-entry__tab-forgot--link" role="button" href="#">Resend OTP</a>
                        </div>
                    </div>
                </Col>
            </Row>
            <Form>
                <Row form>
                    <Col sm="12">
                        <OtpInputNumber
                            value={state.otp}
                            changeEvent={handleChange}
                            otpError={state.otpError}
                        />
                        {props.otpError ? <div className="ebw-error mt-2">{props.otpError}</div> : ""}
                        {resendOtpError ? <div className="ebw-error mt-2">{resendOtpError}</div> : ""}
                        {resendOtpSuccess ? <div className="ebw-success mt-2">{resendOtpSuccess}</div> : ""}
                    </Col>

                    <Col md="6" lg="8" xl="6" className="mt-5 mx-auto">
                        <div className="d-flex justify-content-between">
                            <div className="me-3">
                                <ButtonsSecondary 
                                    clickEvent={handleBack} 
                                    type="button" 
                                    text="Back" 
                                />
                            </div>
                            <div>
                                <Buttons 
                                    clickEvent={() => {
                                        // Clear all errors before verification
                                        if (props.onOtpErrorClear) {
                                            props.onOtpErrorClear();
                                        }
                                        dispatch(clearRegisterResendOtpMessages());
                                        
                                        // Frontend validation - check if OTP is empty
                                        if (!state.otp || state.otp.trim() === '') {
                                            setState((prevProps) => ({
                                                ...prevProps,
                                                otpError: "Please enter the OTP"
                                            }));
                                            return; // Don't proceed with API call
                                        }
                                        
                                        // Clear any existing OTP error if validation passes
                                        setState((prevProps) => ({
                                            ...prevProps,
                                            otpError: ""
                                        }));
                                        
                                        props.handeleOtpVerification(state.otp, registerPersonal.data.confirmation_token);
                                    }} 
                                    type="button" 
                                    text={props.buttonName} 
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Form>
            <Modal isOpen={isOpen}>
                        <div className="px-5 py-5 ebw-modal__wrap">
                            <ModalHeader toggle={toggleModal} className="ebw-profile__modal-head mb-4" style={{ border: "none" }}>
                                <div className="ebw-modal__title mb-1">Edit mobile number </div>
                                <div className="ebw-modal__para">We will send you an access code via mobile for verification.</div>
                            </ModalHeader>

                            <ModalBody className="ebw-modal__body">
                                <form className="ebw-modal__form">
                                    <div className="ebw-modal__input-wrap mb-2">
                                        <InputNumber
                                            changeEvent={(e) => handleMobileChange(e)}
                                            value={state.changedMobileNumber}
                                            className="ebw-modal__input"
                                            placeholder="Enter new mobile number"
                                            error={state.changedMobileNumberError}
                                            required
                                        />
                                        {state.apiError && (
                                            <div className="ebw-error mt-2 text-left">
                                                {state.apiError}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-right">
                                        <button
                                            onClick={(e) => numberUpdate(e)}
                                            className="ebw-modal__submit ebw-button__primary"
                                            type="submit">Verify</button>
                                    </div>
                                </form>
                            </ModalBody>
                        </div>
            </Modal>
        </>
    );
}

export default LoginOTP;